import * as React from 'react'

import Alert from '@mui/material/Alert'
import CircularProgress from '@mui/material/CircularProgress'

type Props = {
  status: 'pending' | 'success' | 'fail'
}

export function CampaignTrackingProviderAlerts(props: Props) {
  const { status } = props

  const pending = status === 'pending'
  const fail = status === 'fail'

  return (
    <>
      {pending && <CircularProgress />}
      {fail && (
        <Alert severity="error">
          Failed to load Call Tracking Account Data.
        </Alert>
      )}
    </>
  )
}
